import { Grid } from "@mui/material";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import React, { useEffect, useState } from "react";
import { useStore } from "utils/useStore";
import AcxButton from "components/UI/AcxButton";
import { ApplicationFilterValuesStore } from "stores/ApplicationFilters/ApplicationFilterValuesStore";
import { observer } from "mobx-react";
import Agentv2 from "models/Agentv2";
import AcxSelectSingleAsync from "components/UI/Select/BaseSelectComponents/AcxSelectSingleAsync";
import { getAgentOptionLabel } from "components/ApplicationFilters/FiltersAndChips/BaseFilterComponents";
import { Suggestion } from "../Suggestions/Suggestion";
import { useCurrentChatStore } from "components/KBo/Stores/useCurrentChat";

export const SelectAgentAction = observer(({ args }) => {
    const currentChatStore = useCurrentChatStore();
    const valuesStore = useStore(ApplicationFilterValuesStore);
    const [agent, setAgent] = useState<Agentv2 | undefined>();
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        if (!dialogOpen) return;
        if (!!valuesStore.userClassifiers) return;
        valuesStore.loadUserClassifiers();
    }, [dialogOpen, valuesStore]);

    const isLoading =
        valuesStore.getTaskLoading("Get Agent") ||
        valuesStore.getTaskLoading("Search Agents");

    return (
        <React.Fragment>
            <AcxDialog
                isOpen={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                }}
                title="Select Agent"
                maxWidth="lg"
                dialogContentChildren={
                    <AcxSelectSingleAsync
                        fullWidth
                        isLoading={isLoading}
                        loadOptions={(input) => valuesStore.searchAgent(input)}
                        cacheOptions
                        isClearable
                        onChange={(agent?: Agentv2) => {
                            setAgent(agent);
                        }}
                        enableNoSelection
                        valueField="id"
                        labelField={getAgentOptionLabel}
                        id="conversations-filter-agent-async-select"
                        noOptionMessage="Please enter First, Last, Agent Code, or Email"
                    />
                }
            >
                <AcxButton
                    fullWidth={false}
                    onClick={() => {
                        if (!agent) return;
                        currentChatStore?.streamingSubmitInput({
                            userMessage: agent.fullName,
                            manualInput: `Now filter by agent name: ${agent.fullName} with ID: "${agent.id}"`,
                        });
                    }}
                    disabled={!agent}
                >
                    Use selected agent
                </AcxButton>
            </AcxDialog>
            <Grid item>
                <Suggestion onClick={() => setDialogOpen((open) => !open)}>
                    {args?.buttonText || "Select Agent"}
                </Suggestion>
            </Grid>
        </React.Fragment>
    );
});
